// Poll & Voting, see https://github.com/ElninhoConsulting/Html5V2/wiki/Poll-And-Voting

// Raw poll as received in CustomMessageType.PlayerPolls = 58 (keys camelCased by WsService)
export interface PollDTO {
    id: number;
    name: string;
    option1: string;
    option2: string;
    option3: string;
    option4: string;
    expireOn: string; // ISO date, e.g. "2025-07-30T16:01:53Z"
}

export interface PollOption {
    // 1..4, sent to the server as Value2 of ClientMsgType.PlayerVote
    value: number;
    label: string;
}

export interface Poll {
    id: number;
    name: string;
    // only non-empty options, max 4
    options: PollOption[];
    expireOn: Date;
}

export const MAX_POLL_OPTIONS = 4;

export function toPoll(dto: PollDTO): Poll {
    const options: PollOption[] = [dto.option1, dto.option2, dto.option3, dto.option4]
        .map((label, index) => ({ value: index + 1, label: (label ?? '').trim() }))
        .filter(option => option.label.length > 0)
        .slice(0, MAX_POLL_OPTIONS);

    return {
        id: dto.id,
        name: dto.name,
        options,
        expireOn: new Date(dto.expireOn)
    };
}
